import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useOrderPause } from "./OrderPauseContext";
import { addOrder } from "../components/liveOrder/liveOrder.store";
// import { getToken } from '../lib/authToken';
import { getUser } from "../lib/authToken";

const WebSocketContext = createContext();

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error("useWebSocket must be used within a WebSocketProvider");
  }
  return context;
};

export const WebSocketProvider = ({ children }) => {
  const [wsConnected, setWsConnected] = useState(false);
  const wsRef = useRef(null);
  const { isPaused } = useOrderPause();
  const isPausedRef = useRef(isPaused);

  useEffect(() => {
    isPausedRef.current = isPaused;
  }, [isPaused]);

  useEffect(() => {
    const connectWebSocket = () => {
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        return; // Already connected
      }

      const apiUrl = new URL(window._env_.API_BASE_URL);
      const wsProtocol = apiUrl.protocol === "https:" ? "wss:" : "ws:";
      // const token = getToken();

      const user = getUser();
      const token = user?.restaurant_id ?? null;
      const wsUrl = `${wsProtocol}//${apiUrl.hostname}/ws/orders?token=${token}`;
      console.log("WebSocket URL:", wsUrl);

      wsRef.current = new WebSocket(wsUrl);

      wsRef.current.onopen = () => {
        console.log("✅ WebSocket connected");
        setWsConnected(true);
      };

      wsRef.current.onmessage = (event) => {
        try {
          if (isPausedRef.current) return;

          const orderData = JSON.parse(event.data);
          addOrder(orderData);
          console.log("📦 New order received:", orderData);
        } catch (err) {
          console.error("❌ WS parse error:", err);
        }
      };

      wsRef.current.onclose = () => {
        console.error("❌ WebSocket disconnected");
        setWsConnected(false);
        // Attempt to reconnect after a delay
        setTimeout(connectWebSocket, 5000);
      };

      wsRef.current.onerror = (err) => {
        console.error("❌ WebSocket error:", err);
        setWsConnected(false);
      };
    };

    connectWebSocket();

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, []);

  // Update global status for console checking
  useEffect(() => {
    window.wsStatus = wsConnected;
  }, [wsConnected]);

  // Log status on page navigation
  useEffect(() => {
    const handleNavigation = () => {
      console.log(
        `🔄 Page navigated - WebSocket ${
          wsConnected ? "connected" : "disconnected"
        }`
      );
    };

    window.addEventListener("popstate", handleNavigation);

    // Also log on initial load
    handleNavigation();

    return () => {
      window.removeEventListener("popstate", handleNavigation);
    };
  }, [wsConnected]);

  return (
    <WebSocketContext.Provider value={{ wsConnected }}>
      {children}
    </WebSocketContext.Provider>
  );
};
